'use client';

import React, { useCallback } from 'react';
import StakeModalContent from '../StakeModalContent';
import UnstakeModalContent from '../UnstakeModalContent';
import useModal from 'src/components/Modals/hooks/useModal';
import { SpotMarketConfig } from '@drift-labs/sdk';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';
import { StakingAction } from 'src/components/Staking/types';
import useStakingTabs from 'src/components/Staking/hooks/useStakingTabs';

export interface StakeModalProps {
	isDriftStaking?: boolean;
	initialTab?: StakingAction;
	selectedIfStakeMarket: SpotMarketConfig;
}

const StakeModal = ({
	initialTab = 'stake',
	isDriftStaking,
	selectedIfStakeMarket,
}: StakeModalProps) => {
	const { hide, canGoBack, goBack } = useModal();

	const { tabOptions, selectedTab, setSelectedTab } = useStakingTabs({
		initialTab,
	});

	const onConfirm = useCallback(() => {
		canGoBack ? goBack() : hide();
	}, [canGoBack, goBack, hide]);

	return (
		<ResponsiveModal.Container onClose={hide} dataTestId="stake-modal">
			<ResponsiveModal.Title
				tabs={tabOptions}
				activeTab={selectedTab}
				onTabChange={setSelectedTab}
				closeButtonTestId="stake-modal-close"
			>
				{isDriftStaking ? 'DRIFT Staking' : 'Insurance Fund Staking'}
			</ResponsiveModal.Title>
			{selectedTab === 'stake' && (
				<StakeModalContent
					onConfirm={onConfirm}
					selectedIfStakeMarket={selectedIfStakeMarket}
					isDriftStaking={isDriftStaking}
				/>
			)}
			{selectedTab === 'unstake' && (
				<UnstakeModalContent
					onConfirm={onConfirm}
					selectedIfStakeMarket={selectedIfStakeMarket}
					isDriftStaking={isDriftStaking}
				/>
			)}
		</ResponsiveModal.Container>
	);
};

export default React.memo(StakeModal);
